export default {
    getAllSelected: (state) => () => {
        return state.list.filter((item) => item._selected);
    },
};
